import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Modal } from '@els/els-react--modal';
import InnerHTML from '@Components/InnerHTML';
import { LEGACY_DIALOG_SIZE } from '@Containers/Dialogs/DialogsConstants';

import './DialogsWithIcon.scss';

const SIZE_TO_WIDTH = {
  sm: '26rem',
  md: LEGACY_DIALOG_SIZE, // 31.875rem
  lg: '50rem',
  xl: '60rem',
};

export default function DialogsWithIcon(props) {
  const {
    className,
    header,
    children,
    content,
    footer,
    html,
    selfClose,
    character,
    layoutType = 'info',
    headerClassName,
    footerClassName,
    contentClassName,
    headerTitleClassName,
    headerTitleIconClassName,
    noBorder = true,
    preHeader,
    noContent,
    size,
    closeBtn = true,
    label,
  } = props;

  const contentToRender = children || content;
  const modalWidth = SIZE_TO_WIDTH[size] ?? LEGACY_DIALOG_SIZE;
  const modalLabel = label || (typeof header === 'string' && header ? header : 'Dialog');

  return (
    <Modal
      onClose={selfClose}
      label={modalLabel}
      className={classnames(className, 'dialog-with-icon-layout')}
      width={modalWidth}
      shouldHideCloseButton={!closeBtn}>
      {header && (
        <header className={classnames(headerClassName, { 'rx-border-none': noBorder })}>
          {preHeader}
          <div className="dialog-with-icon-layout-header-wrapper">
            <div
              className={classnames(
                headerTitleIconClassName,
                'dialog-with-icon-layout-header-icon',
                `dialog-with-icon-layout-header-icon-${layoutType}`
              )}>
              {character}
            </div>
            <h4
              className={classnames(headerTitleClassName, 'dialog-with-icon-layout-header-title', {
                'no-content': noContent,
              })}>
              {header || <>&nbsp;</>}
            </h4>
          </div>
        </header>
      )}
      {!!(contentToRender || html) && (
        <section className={classnames(contentClassName, 'dialog-with-icon-layout-content-wrapper')}>
          {html ? <InnerHTML tag="span" html={html} /> : contentToRender}
        </section>
      )}
      {footer && <footer className={classnames(footerClassName, { 'rx-border-none': noBorder })}>{footer}</footer>}
    </Modal>
  );
}

DialogsWithIcon.propTypes = {
  character: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  layoutType: PropTypes.oneOf(['error', 'info', 'question', 'success']),
  size: PropTypes.oneOf(['fit', 'sm', 'md', 'lg', 'xl']),
  closeBtn: PropTypes.bool,
  label: PropTypes.string,
  headerClassName: PropTypes.string,
  footerClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  headerTitleClassName: PropTypes.string,
  headerTitleIconClassName: PropTypes.string,
  noBorder: PropTypes.bool,
  noContent: PropTypes.bool,
  header: PropTypes.any,
  footer: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  html: PropTypes.string,
  selfClose: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node,
  preHeader: PropTypes.node,
};
